import { useQuery } from '@apollo/client';

import { EnterpriseSignupCustomBrandingDocument } from 'src/gql/graphql';
import '../queries/enterprise-signup-custom-branding.gql';

type UseEnterpriseSignupCustomBrandingParams = {
  enterpriseId?: string;
};

type UseEnterpriseSignupCustomBrandingReturn = {
  /** Defaults to false (fallback styling) while loading or on error -- never blocks on this. */
  customBrandingEnabled: boolean;
  loading: boolean;
};

// POS-17999 -- growth.ecomm.enterprise-signup-custom-branding.rollout, evaluated server-side by
// apps/api per-enterprise. Kept as its own query/hook (see enterprise-signup-custom-branding.gql
// for why) but fetched in parallel with useSearchEnterprise, not after it.
export function useEnterpriseSignupCustomBranding({
  enterpriseId,
}: UseEnterpriseSignupCustomBrandingParams): UseEnterpriseSignupCustomBrandingReturn {
  const { data, loading } = useQuery(EnterpriseSignupCustomBrandingDocument, {
    variables: { enterpriseId: enterpriseId ?? '' },
    skip: !enterpriseId,
  });

  return {
    customBrandingEnabled: data?.enterpriseSignupCustomBrandingEnabled ?? false,
    loading,
  };
}
